import { Component, Mixins, Prop } from 'vue-property-decorator';
import { UtilMixin } from '../../UtilMixin';
import SuggestionEntryCardHeader from './suggestionEntryCardHeader.vue';
import SuggestionEntryMetadata from './suggestionEntryMetadata.vue';
import SuggestionSource from './suggestionSource.vue';

@Component({
  components: {
    SuggestionEntryCardHeader,
    SuggestionEntryMetadata,
    SuggestionSource,
  },
})
export default class SuggestionEntryCard extends Mixins(UtilMixin) {
  @Prop() private suggestion!: any;

  get suggestionClass() {
    switch (this.suggestion.status.code) {
      case 'CREATED':
        return 'suggestion-created';
      case 'ACCEPTED':
        return 'suggestion-accepted';
      case 'REJECTED':
        return 'suggestion-rejected';
    }
  }
}
